export default class Mov {
    constructor() {
        this.prev = 'portrait';

        this._init();
    }

    _init() {
        this._getEl();
        this.changeMov();
    }

    _getEl() {
        this.$mov = document.querySelector('.js-mov');
    }

    changeMov() {
        const isPortrait = window.matchMedia('(orientation: portrait)'),
            current = isPortrait.matches ? 'portrait' : 'landscape';

        if (!this.$mov || this.prev == current) return;

        this.$mov.src = `assets/mov/bg_earth_${current}.mp4`;
        this.prev = current;
    }
}
